// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"7ae942d1","283":"cc6239bd","355":"105b3e02","531":"3a8c9a86","633":"7270d309","736":"c214e95b"}[chunkId] + ".chunk.js";
};